module.exports = __webpack_public_path__ + "static/media/menu_icon_yl.aeab7bf7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_icon_yl.svg
// module id = 263
// module chunks = 0